// src/components/admin/AddUserModal.tsx

import { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";

interface AddUserModalProps {
  show: boolean;
  onHide: () => void;
  onSave: (email: string, role: string) => void;
}

export const AddUserModal = ({ show, onHide, onSave }: AddUserModalProps) => {
  const [email, setEmail] = useState("");
  const [role, setRole] = useState("client");

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSave(email, role);
    onHide();
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Form onSubmit={handleSubmit}>
        <Modal.Header closeButton>
          <Modal.Title>Add User</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group className="mb-3" controlId="formEmail">
            <Form.Label>Email</Form.Label>
            <Form.Control
              type="email"
              placeholder="Enter email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </Form.Group>

          <Form.Group className="mb-3" controlId="formRole">
            <Form.Label>Role</Form.Label>
            <Form.Select
              value={role}
              onChange={(e) => setRole(e.target.value)}
            >
              <option value="owner">Owner</option>
              <option value="admin">Admin</option>
              {/* <option value="manager">Manager</option> */}
              <option value="client">Client</option>
            </Form.Select>
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="danger" onClick={onHide}>
            Cancel
          </Button>
          <Button variant="primary" type="submit">
            Save
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default AddUserModal;
